export const AUTH_TOKEN_KEY = 'byo.auth';
export const AUTH_QUERY_PARAM = 'ffCipher';
export const AUTH_HEADER_KEY = 'x-byo-authorization';
